import { Outlet } from 'react-router-dom';
import Sidebar from '../components/navigation/Sidebar';
import ReferralInboxPoller from '../components/notifications/ReferralInboxPoller';
import IncomingCallListener from '../components/notifications/IncomingCallListener';
import ReplyUnreadListener from '../components/notifications/ReplyUnreadListener';
import GpsTracker from '../components/notifications/GpsTracker';
import PhoneRequiredDialog from '../components/users/PhoneRequiredDialog';
import { useUI } from '../store/UIContext';
import { useAuth } from '../store/AuthContext';
import { ToastContainer } from '../components/ui/index';
import { isWorkspaceRole } from '../utils/roleHelpers';
import { WorkspaceProvider } from '../store/WorkspaceContext';
import AppBackground from '../components/decoration/AppBackground';
import Breadcrumb from '../components/navigation/Breadcrumb';

export default function AppLayout() {
  const { toasts, removeToast, sidebarOpen, setSidebarOpen } = useUI();
  const { user } = useAuth();

  // The multi-tab workspace's tab state has to live above both Sidebar
  // (which opens/focuses tabs from its menu) and the routed page itself
  // (which renders them) - only mounted at all for the roles the feature is
  // scoped to, so every other role's Sidebar/page tree is unaffected.
  const body = (
    <>
      {/* Mobile-only top bar */}
      <div className="pj-topbar">
        <button className="pj-hamburger" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="باز کردن منو">
          <span className={`pj-hamburger-bar${sidebarOpen ? ' open' : ''}`} />
        </button>
        <img src="/pejvak-mark.svg" alt="پژواک رایانه" width={26} height={26} style={{ borderRadius: 6 }} />
        <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--gray-900)' }}>پژواک رایانه</span>
      </div>

      <div className={`pj-sidebar-overlay${sidebarOpen ? ' open' : ''}`} onClick={() => setSidebarOpen(false)} />

      <Sidebar />
      <ReferralInboxPoller />
      <ReplyUnreadListener />
      <IncomingCallListener />
      <GpsTracker />
      <main className="pj-main">
        <Breadcrumb />
        <Outlet />
      </main>
      <ToastContainer toasts={toasts} onRemove={removeToast} />
      <PhoneRequiredDialog />
    </>
  );

  return (
    <div dir="rtl" style={{ display: 'flex', minHeight: '100vh', background: 'var(--surface-2)' }}>
      <AppBackground />
      {isWorkspaceRole(user?.type) ? <WorkspaceProvider>{body}</WorkspaceProvider> : body}
    </div>
  );
}
